import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import {
  Badge,
  Card,
  CardHeader,
  Table,
  Row,
  Col,
  Button,
} from 'reactstrap'
import { useFetch } from '../../hooks'
import { api } from '../../utils'
import { notify } from '../../utils/notify'
import { ToastContainer } from 'react-toastify'
import Header from "../../components/Headers/Header";

const LLMVisibilityListing = () => {
  const history = useHistory()
  const itemPerPage = 10

  const [pages, setPages] = useState(0)
  const [tableData, setTableData] = useState([])
  const [actualPage, setActualPage] = useState(1)

  const { data, info, loading, error } = useFetch({
    url: 'llm-visibility/',
    params: { page_size: itemPerPage },
  })

  useEffect(() => {
    if (data.length > 0 && tableData.length === 0) {
      setTableData(data)
      setPages(Math.ceil(info.count / itemPerPage))
    }
  }, [data, info, tableData])

  const handlePageClick = (data) => {
    const currentPage = data.selected + 1
    setActualPage(currentPage)
    api
      .get('llm-visibility/', {
        params: {
          page_size: itemPerPage,
          page: currentPage,
        },
      })
      .then((response) => {
        setTableData(response.data.results)
        setPages(Math.ceil(response.data.count / itemPerPage))
      })
      .catch((error) => console.error(error))
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'EXPORTED':
        return 'success'
      case 'EXPORTED_QUESTIONS':
        return 'info'
      case 'ERROR':
        return 'danger'
      case 'CREATED':
        return 'primary'
      default:
        return 'warning'
    }
  }

  const getStatusLabel = (status) => {
    switch (status) {
      case 'EXPORTED_QUESTIONS':
        return 'EXPORTED (QUESTIONS ONLY)'
      default:
        return status
    }
  }

  return (
    <Header
      iconClass="ni ni-align-left-2 text-white"
      title="LLM Visibility"
      description={"Dato un set di Keyword, genera delle domande per gli LLM e controlla quanto i brand vengono citati in esse"}
    >
      {loading && <div className="text-center"><Spinner animation="grow" /></div>}
      {tableData && (
        <Row style={{ marginBottom: '100px' }}>
          <div className="col pb-5">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h1 className="mb-0">LLM Visibility Reports</h1>
                  </Col>
                  <Col className="text-right" xs="4">
                    <Button
                      color="info"
                      onClick={() => history.push('/add-llm-visibility/')}
                      size="md"
                    >
                      + Add New
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Date</th>
                    <th scope="col">Connected Tagging</th>
                    <th scope="col">Status</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item) => (
                    <tr key={item.id}>
                      <th scope="row">
                        <Link to={`/add-llm-visibility/${item.id}`}>{item.name}</Link>
                      </th>
                      <td>{new Date(item.created).toLocaleDateString()}</td>
                      <td>
                        {item.connected_tagging ? (
                          <Link to={`/reporting/reports/seo/${item.connected_tagging}`}>View Report</Link>
                        ) : (
                          'N/A'
                        )}
                      </td>
                      <td>
                        <Badge color={getStatusBadge(item.status)} pill className="text-white">
                          {getStatusLabel(item.status)}
                        </Badge>
                      </td>
                      <td className="text-right">
                        {/* Actions can be added here, e.g., a rerun button */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pages}
                forcePage={actualPage - 1}
                onPageChange={handlePageClick}
                containerClassName={'pagination justify-content-center pt-5 pb-3'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}
              />
            </Card>
          </div>
        </Row>
      )}
      <ToastContainer />
    </Header>
  )
}

export default LLMVisibilityListing
